if (!customElements.get('lc-shoppable-videos')) {
  customElements.define(
    'lc-shoppable-videos',
    class LcShoppableVideos extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('lc-slider');
        this.fractionText = this.querySelector('.lc-shoppable-videos__fraction-text');
        this.videos = this.querySelectorAll('.lc-shoppable-videos__video');

        this.addEventListener('click', (e) => this.handleClick(e));

        if (this.slider) {
          this.slider.addEventListener('lc-slider:init', (e) => this.handleSliderUpdate(e.detail.swiper));
          this.slider.addEventListener('lc-slider:slidechange', (e) => this.handleSliderUpdate(e.detail.swiper));
        }

        this.initIntersectionObserver();
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }

      initIntersectionObserver() {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target.querySelector('.lc-shoppable-videos__video');
              if (video) {
                if (entry.isIntersecting) {
                  video.play().catch(() => {});
                } else {
                  video.pause();
                  video.muted = true;
                  const slide = entry.target;
                  slide.classList.remove('lc-shoppable-videos__slide--playing-audio');
                }
              }
            });
          },
          { threshold: 0.3 }
        );

        const slides = this.querySelectorAll('.lc-shoppable-videos__slide');
        slides.forEach((slide) => this.observer.observe(slide));
      }

      handleClick(e) {
        const productCard = e.target.closest('.lc-shoppable-videos__product-card');
        if (productCard) {
          const quickViewBtn = e.target.closest('.lc-shoppable-videos__quick-view-btn');
          if (quickViewBtn) {
            e.preventDefault();
            e.stopPropagation();
            const modalId = quickViewBtn.getAttribute('aria-controls');
            const modal = document.getElementById(modalId);
            if (modal && typeof modal.show === 'function') {
              modal.show(quickViewBtn);
            }
          }
          return;
        }

        const mediaWrapper = e.target.closest('.lc-shoppable-videos__media-wrapper');
        if (mediaWrapper) {
          const video = mediaWrapper.querySelector('.lc-shoppable-videos__video');
          if (video) {
            this.toggleVideoAudio(video, mediaWrapper);
          }
        }
      }

      toggleVideoAudio(video, mediaWrapper) {
        const slide = mediaWrapper.closest('.lc-shoppable-videos__slide');
        if (video.muted) {
          video.muted = false;
          video.play().catch(() => {});
          slide.classList.add('lc-shoppable-videos__slide--playing-audio');

          this.videos.forEach((otherVideo) => {
            if (otherVideo !== video) {
              otherVideo.muted = true;
              otherVideo.pause();
              const otherSlide = otherVideo.closest('.lc-shoppable-videos__slide');
              if (otherSlide) {
                otherSlide.classList.remove('lc-shoppable-videos__slide--playing-audio');
              }
            }
          });
        } else {
          video.muted = true;
          slide.classList.remove('lc-shoppable-videos__slide--playing-audio');
        }
      }

      handleSliderUpdate(swiper) {
        if (this.fractionText && swiper) {
          const current = swiper.realIndex + 1;
          const total = swiper.slides.length;
          this.fractionText.textContent = `${current} / ${total}`;
        }
      }
    }
  );
}
